export const ApiActions = {
    // Authentication actions
    LOGIN_USER: 100,
    REGISTER_USER: 101,
    SAVE_USER: 102,
    REQUEST_PASSWORD_RESET: 103,
    RESET_PASSWORD: 104,
    DELETE_ACCOUNT: 105,
    VERIFY_EMAIL: 106,
    VERIFY_EMAIL_CODE: 110,
    RESEND_VERIFICATION: 107,
    SUBMIT_CONTACT_MESSAGE: 108,
    GOOGLE_AUTH: 109,

    // Trip-related actions
    CREATE_TRIP: 200,
    UPDATE_TRIP: 201,
    DELETE_TRIP: 202,
    GET_TRIPS: 203,
    GET_ATTRACTIONS: 205,
    GET_ATTRACTION_IMAGES: 207,
    GET_IMAGES_BY_TERM: 208,
    
    // User actions
    UPDATE_USER_PROFILE: 300,
    GET_USER_DATA: 304,
    GET_ACCOUNT_DATA: 305,
    UPDATE_ACCOUNT_SETTINGS: 306,
    CHECK_USAGE_LIMITS: 307,
    
    // Plan actions
    CREATE_PLAN: 400,
    GET_PLANS: 401,
    GET_PLAN_BY_ID: 402,
    UPDATE_PLAN: 403,
    DELETE_PLAN: 404,
    
    // Settings actions
    GET_SETTINGS: 500,
    UPDATE_SETTINGS: 502,
    
    // Currency actions
    GET_HISTORICAL_RATES: 501,
    REFRESH_CURRENCY_RATES: 503,
    
    // Stripe/Payment actions
    CREATE_CHECKOUT_SESSION: 600,
    CREATE_BILLING_PORTAL_SESSION: 601,
    CANCEL_SUBSCRIPTION: 602,
    GET_TOKEN_USAGE: 603,
    
    // Admin actions
    GET_CONTACT_MESSAGES: 700,
    UPDATE_CONTACT_MESSAGE_STATUS: 701,
    DELETE_CONTACT_MESSAGE: 702,
    
    // QR Items actions
    CREATE_QR_ITEM: 800,
    GET_QR_ITEMS: 801,
    UPDATE_QR_ITEM: 802,
    DELETE_QR_ITEM: 803,
    
    // PDF Export actions
    EXPORT_PLAN_PDF: 900
}; 